import { Status } from '../models/status.interfaces';

export const GoldMedallionBannerStatusMocks: Status = {
  priority: {
    label: '',
    url: '',
    active: false
  },
  tier: {
    title: '2023 CURRENT STATUS: ',
    subtitle: 'GOLD MEDALLION®',
    level: '0',
    name: 'gold'
  },
  enrollDate: 'SKYMILES MEMBER SINCE 2004'
};

export const GoldMedallionBannerWithSkyPriorityStatusMocks: Status = {
  priority: {
    label: 'SKY PRIORITY',
    url: '/us/en/check-in-security/sky-priority',
    active: true
  },
  tier: {
    title: '2023 CURRENT STATUS: ',
    subtitle: 'GOLD MEDALLION®',
    level: '1',
    name: 'gold'
  },
  enrollDate: 'SKYMILES MEMBER SINCE 2004'
};

export const GoldMedallionBannerStatusWithLifetimeMocks: Status = {
  priority: {
    label: '',
    url: '',
    active: false
  },
  tier: {
    title: '',
    subtitle: '',
    level: '0',
    name: 'gold'
  },
  enrollDate: 'SKYMILES MEMBER SINCE 2004'
};

export const GoldMedallionBannerWithSkyPriorityStatusWithLifetimeMocks: Status =
  {
    priority: {
      label: 'SKY PRIORITY',
      url: '/us/en/check-in-security/sky-priority',
      active: true
    },
    tier: {
      title: '',
      subtitle: '',
      level: '1',
      name: 'gold'
    },
    enrollDate: 'SKYMILES MEMBER SINCE 2004'
  };
